export function buildCommentsToResync (missingAddons, addons, occurrenceId) {
  if (!Array.isArray(missingAddons)) return []
  const byItem = addons || {}
  return missingAddons
    .filter(addon => addon.type === 'comment')
    .map(addon => {
      const local = (byItem[addon.item_id] || []).find(a => a.type === 'comment')
      const answer = local?.answer
      if (typeof answer !== 'string' || answer === '') return null
      return {
        item_id: addon.item_id,
        type: 'comment',
        answer,
        occurrence_id: occurrenceId,
        form_assignment_location_occurrence_id: occurrenceId
      }
    })
    .filter(Boolean)
}

// Límites del addon de video. `OccurrenceItemAddonDialog.vue` acepta solo 3 de estos 4 tipos en su selector de archivos
// (sin video/x-msvideo): esta constante no se comparte con el .vue para no cambiar lo que acepta el selector.
export const VIDEO_MAX_BYTES = 45 * 1024 * 1024
export const VIDEO_ALLOWED_MIMES = new Set(['video/mp4', 'video/quicktime', 'video/webm', 'video/x-msvideo'])

// Clave i18n del error si el archivo no es un video válido (tipo o tamaño), o null si lo es.
export function validateVideoFile (file) {
  if (!(file instanceof Blob)) return 'validations.video_invalid'
  if (file.type && !VIDEO_ALLOWED_MIMES.has(file.type)) return 'validations.video_invalid'
  if (file.size > VIDEO_MAX_BYTES) return 'forms.addons.video_too_large'
  return null
}
